import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface ProjectTypeItem {
    id: number;
    name: string;
    countryId: number;
    countryName: string;
    createdDateTime?: Date;
    updatedDateTime?: Date;
}

@Injectable({
    providedIn: 'root',
})
export class TermsAndConditionsService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/terms-and-condition`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }


    /**
     * Get all
     */
    public getAll(
        pageIndex?: number,
        pageSize?: number,
        searchValue?: string,
        countryId?: number | number[]
    ): Observable<{ data: ProjectTypeItem[]; paginatorValue: { totalData: number; totalCount: number } }> {
        let params = new HttpParams();
        if (pageIndex !== undefined && pageIndex !== null) {
            params = params.set('pageIndex', pageIndex.toString());
        }
        if (pageSize !== undefined && pageSize !== null) {
            params = params.set('pageSize', pageSize.toString());
        }
        if (searchValue && searchValue.trim() !== '') {
            params = params.set('searchValue', searchValue.trim());
        }
        if (countryId !== undefined && countryId !== null) {
            if (Array.isArray(countryId)) {
                if (countryId.length > 0) {
                    params = params.set('countryIds', countryId.join(','));
                }
            } else {
                params = params.set('countryId', countryId.toString());
            }
        }
        return this.http
            .get<{ data: ProjectTypeItem[]; paginatorValue: { totalData: number; totalCount: number } }>(`${this.URL_PATH}/getAll`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Create a new 
     */
    public create(name: string, countryId: number): Observable<{ message: string; result: ProjectTypeItem }> {
        return this.http
            .post<{ message: string; result: ProjectTypeItem }>(`${this.URL_PATH}/create`, { name, countryId })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Update an existing
     */
    public update(id: number, name: string, countryId: number): Observable<{ message: string; result: ProjectTypeItem }> {
        return this.http
            .put<{ message: string; result: ProjectTypeItem }>(`${this.URL_PATH}/update/${id}`, { name, countryId })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Delete a 
     */
    public delete(id: number): Observable<{ message: string }> {
        return this.http
            .delete<{ message: string }>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}

